const RequestState = Object.freeze({
  Return: 0,
  Reject: 1,
  Approve: 3,
  Delete: 4
})
//debugger

export default { RequestState };